import { DEFAULT_EARLIEST, DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import currencyModelValidator from 'forms/shared/validators/models/currency';
import { isPVQForm } from 'helpers/form';
import pvqLocationModelValidator from 'forms/shared/validators/models/location/pvqLocation';
import locationAddressModelValidator from 'forms/shared/validators/models/location/models/address';
import { travelCardActionOptions, travelCardDisciplinaryOptions } from 'constants/enums/financialOptions';
import { setToStartOfMonth } from 'helpers/date';
import { REQUIRED } from 'constants/errors';
import { FinancialCardAbuseItemModel } from '../types';

const financialCardAbuseItemValidator: ValidateJSModel<FinancialCardAbuseItemModel> = {
  Agency: { presence: true, hasValue: true },

  Address: (value, attributes, attributeName, options) => ({
    presence: true,
    location: { validator: isPVQForm(options?.formType) ? pvqLocationModelValidator : locationAddressModelValidator },
  }),

  Date: (value, attributes, attributeName, options) => {
    if (options?.requireFinancialCardDisciplinaryDate) {
      return {
        presence: true,
        date: { requireDay: false, earliest: options?.applicantBirthdate, latest: DEFAULT_LATEST },
      };
    }

    return {};
  },

  Reason: (value, attributes, attributeName, options) => ((isPVQForm(options?.formType)) ? {} : { hasValue: true }),

  Amount: {
    model: {
      validator: currencyModelValidator,
    },
  },

  AmountEstimated: {},

  Description: { hasValue: true },

  DisciplinaryAction: (value, attributes, attributeName, options) => (isPVQForm(options?.formType) ? {
    array: {
      validator: {
        inclusion: {
          within: travelCardDisciplinaryOptions.getValues(),
        },
      },
      length: {
        minimum: 1,
        message: REQUIRED
      }
    },
  } : {}),

  DisciplinaryActionExplanation: (value, attributes, attributeName, options) => (isPVQForm(options?.formType) && (attributes.DisciplinaryAction?.values?.includes('None') || attributes.DisciplinaryAction?.values?.includes('Other')) ? {
    hasValue: true,
  } : {}),

  ActionsTaken: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        array: {
          validator: {
            inclusion: {
              within: travelCardActionOptions.getValues(),
            },
          },
          length: {
            minimum: 1,
            message: REQUIRED
          }
        },
      };
    }

    return {};
  },

  ActionsTakenReason: (value, attributes, attributeName, options) => (isPVQForm(options?.formType) && (attributes.ActionsTaken?.values?.includes('None') || attributes.ActionsTaken?.values?.includes('Other')) ? {
    hasValue: true,
  } : {}),

  WhenDisciplineReceived: (value, attributes, attributeName, options) => (isPVQForm(options?.formType) ? {
    presence: true,
    date: {
      requireDay: false,
      earliest: setToStartOfMonth(options?.applicantBirthdate || DEFAULT_EARLIEST),
      latest: DEFAULT_LATEST
    },
  } : {}),

  WhenDisciplineReceivedEstimated: {},

};

export default financialCardAbuseItemValidator;
